import React from "react";
import { Typography } from "@mui/material";

export default function PageTitle({ small, children, ...props }) {
  return (
    <Typography
      {...props}
      variant={small ? "h2" : "h1"}
      component="h1"
      lineHeight="48px"
      gutterBottom
    >
      {children}
    </Typography>
  );
}